import { createContext, SetStateAction, useContext } from "react";
import { toast } from "react-toastify";
import { iModalRegister } from "../../components/Modal";
import { iProvidersProps } from "../../components/Providers";
import { instace } from "../../services/api";
import { useUserContext } from "../UserContext";
import { iTech } from "../../components/ListTechs";

interface iUseTechProvider {
  techDelete(
    id: string,
    setLoadButton: React.Dispatch<SetStateAction<boolean>>
  ): Promise<void>;
  newTech(
    data: iModalRegister,
    setLoadButton: React.Dispatch<SetStateAction<boolean>>,
    closeModal: () => void
  ): Promise<void>;
}

export const TechContext = createContext<iUseTechProvider>(
  {} as iUseTechProvider
);

const TechProvider = ({ children }: iProvidersProps) => {
  const { techList, setTechList } = useUserContext();

  const newTech = async (
    data: iModalRegister,
    setLoadButton: React.Dispatch<SetStateAction<boolean>>,
    closeModal: () => void
  ): Promise<void> => {
    const token = localStorage.getItem("@kenzieHubToken");

    try {
      setLoadButton(true);
      instace.defaults.headers.common.authorization = `Bearer ${token}`;

      const newTech = await instace.post<iTech>("users/techs", data);

      const newData = [...techList, newTech.data];

      setTechList(newData);
      toast.success("Tecnologia adicionada com sucesso!", {
        autoClose: 3000,
        theme: "dark",
      });
      closeModal();
    } catch (error) {
      toast.error("Tecnologia já existe na sua lista!", {
        autoClose: 3000,
        theme: "dark",
      });
    } finally {
      setLoadButton(false);
    }
  };

  const techDelete = async (
    id: string,
    setLoadButton: React.Dispatch<SetStateAction<boolean>>
  ): Promise<void> => {
    const token = localStorage.getItem("@kenzieHubToken");

    try {
      setLoadButton(true);

      instace.defaults.headers.common.authorization = `Bearer ${token}`;

      await instace.delete(`users/techs/${id}`);
      toast.success("Tecnologia deletada!", {
        autoClose: 3000,
        theme: "dark",
      });

      const newData = techList.filter((tech: iTech) => tech.id !== id);

      setTechList(newData);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadButton(false);
    }
  };

  return (
    <TechContext.Provider value={{ techDelete, newTech }}>
      {children}
    </TechContext.Provider>
  );
};

export const useTechProvider = () => {
  const context = useContext(TechContext);

  return context;
};

export default TechProvider;
